/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Canceldeal_Action_Button2Inputs */

const en_coinvestments_canceldeal_action_button2 = /** @type {(inputs: Coinvestments_Canceldeal_Action_Button2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel Deal`)
};

/**
* | output |
* | --- |
* | "Cancel Deal" |
*
* @param {Coinvestments_Canceldeal_Action_Button2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_canceldeal_action_button2 = /** @type {((inputs?: Coinvestments_Canceldeal_Action_Button2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Canceldeal_Action_Button2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_canceldeal_action_button2(inputs)
});
export { coinvestments_canceldeal_action_button2 as "coInvestments_cancelDeal_action_button" }